import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AttachmentTypeEnum } from '@models/enums/attachment-type-enum';
import { IResponseDto } from '@models/exceptions/response-dto';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TypeAttachmentService {
  private url: string = environment.apiUrl + "/v1/tipos-anexos";

  constructor(
    private httpClient: HttpClient
  ){}

  getAttachmentType$(tipNrId: number): Observable<AttachmentTypeDto>{
    return this.httpClient.get<IResponseDto<AttachmentTypeDto>>(`${this.url}/${tipNrId}`).pipe(
      map(res => res.response)
    )
  }
}

export interface AttachmentTypeDto{
  tipNrId: number,
  tipTxDescricao: AttachmentTypeEnum
}

